import { Popup } from "../components/popup";

export class AjaxFormMananger {
  /** @type {HTMLFormElement[]} */
  forms = [];
  /** @type {HTMLElement | null} */
  dialog = undefined;
  constructor() {
    this.init();
  }

  static CLASS_NAMES = {
    FORM: 'js-ajax-form'
  }

  static ID_NAMES = {
    DIALOG: 'dialog',
    DIALOG_CLOSE_BUTTON: 'dialog_hide',
    DIALOG_LABEL: 'dialog_label',
    DIALOG_DESC: 'dialog_description'
  }

  init() {
    const forms = document.getElementsByTagName('form');
    this.forms = Array.from(forms).filter(form => form.classList.contains(AjaxFormMananger.CLASS_NAMES.FORM)) || [];
    this.dialog = document.getElementById(AjaxFormMananger.ID_NAMES.DIALOG);
    this.dialogCloseButton = document.getElementById(AjaxFormMananger.ID_NAMES.DIALOG_CLOSE_BUTTON);

    this.listen();
  }

  listen() {
    this.forms.forEach(form => {
      form.addEventListener('submit', this.handleFormSubmitEvent.bind(this), { passive: false });
    })
  }

  /**
   * @method handleFormSubmitEvent
   * @param {SubmitEvent} e
   */
  handleFormSubmitEvent(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const submitter = e.submitter || form.querySelector('[type="submit"]');
    this.handleSubmit(form, submitter);
  }

  /**
   * @method handleSubmit
   */
  async handleSubmit(form, submitter) {
    let originalLabel = '';
    if (submitter) {
      submitter.disabled = true;
      originalLabel = submitter.innerHTML;
      submitter.innerHTML = '送信中...';
    }
    try {
      const responseBody = await this.sendAjax(form);
      this.showDialog(responseBody);
    } catch (error) {
      this.showDialog('送信に失敗しました: ' + error.message);
    } finally {
      if (submitter) {
        submitter.disabled = false;
        submitter.innerHTML = originalLabel;
      }
    }
  }

  /**
   *
   * @param {HTMLFormElement} form
   * @returns
   */
  async sendAjax(form) {
    const action = form.action;
    const method = form.method || 'POST';
    const formData = new FormData(form);
    const csrfToken = this.getCsrfToken(form);

    const response = await fetch(action, {
      method: method,
      headers: csrfToken ? { 'X-CSRF-Token': csrfToken } : {},
      body: formData,
    });

    const contentType = response.headers.get('Content-Type');
    if (contentType && contentType.includes('application/json')) {
      const json = await response.json();
      return json;
    } else {
      return await response.text();
    }
  }

  showDialog(responseBodyJson) {
    if (this.dialog == null) return console.warn('dialog is not find.');
    const popup = new Popup(this.dialogCloseButton);
    const label = document.getElementById(AjaxFormMananger.ID_NAMES.DIALOG_LABEL);
    const description = document.getElementById(AjaxFormMananger.ID_NAMES.DIALOG_DESC);
    if (description) {
      description.innerHTML = responseBodyJson.messages;
    }
    if (responseBodyJson.cancel_messages) {
      const cancelMessages = responseBodyJson.cancel_messages
      const cancelButton = document.createElement('button');
      cancelButton.classList.add('c-button', 'u-block--center', 'u-mt--rg-trim');
      cancelButton.setAttribute('aria-haspopup', 'dialog');
      cancelButton.setAttribute('popovertarget', 'dialog');
      cancelButton.setAttribute('popovertargetaction', 'hide');
      cancelButton.setAttribute('aria-expanded', 'true');
      cancelButton.innerHTML = cancelMessages;
      description.appendChild(cancelButton);

      new Popup(cancelButton).listen();

    }
    popup.open();
  }

  getCsrfToken(form) {
    const meta = document.querySelector(`meta[name="${this.csrfMetaName}"]`);
    if (meta) return meta.content;

    const input = form.querySelector(`input[name="${this.csrfFieldName}"]`);
    if (input) return input.value;

    return null;
  }
}
